import {SERVICES_LOADING,LOAD_SERVICES,LOAD_SUB_SERVICES} from './types';
import axios from 'axios';
const URL = `https://powerscript.herokuapp.com/api/`;
const setLoading = () => {
    return {
        type:SERVICES_LOADING
    }
};
const setServices = data => {
    return {
        type:LOAD_SERVICES,
        payload:data
    }
};
const setSubServices = data => {
    return {
        type:LOAD_SUB_SERVICES,
        payload:data
    }
};
export const fetchServices = () => {
    return async dispatch => {
        dispatch(setLoading());
        await axios.get(`${URL}/services/fetchServices`)
        .then(response => {
            return dispatch(setServices(response.data.message));
        }).catch(console.log);
    }
};
export const fetchSubServices = () => {
    return async dispatch => {
        dispatch(setLoading());
        await axios.get(`${URL}/services/fetchServices`)
        .then(response => {
            const services = response.data.message;
            let sub_services = [];
            services.forEach(service => {
                if(service.sub_services.length > 0){
                    for(const elm of service['sub_services']){
                        sub_services.push(elm);
                    }
                }
            });
            return dispatch(setSubServices(sub_services));
        }).catch(console.log);
    }
}